module.exports = __webpack_public_path__ + "static/media/r19.41cfca4a.jpg";